// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const DatabaseSections = styled.div`  
  display: grid;
  font-size: 1.6em;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
  margin-top: 1em;
  text-transform: uppercase;
`

export const DecoratedLink = styled(Link)`
  align-items: center;
  border-color: transparent;
  color: white;
  display: flex;
  justify-content: center;
  transition-duration: .9s;
  transition-property: filter, border-color;
  transition-timing-function: ease;
  // overrides default link styles.
  text-decoration: none;
  transform: translate3d(0, 0, 0);
  
  &:hover {
    // $blue-dark: #335c84; in SCSS variables
    filter: drop-shadow(.125em .125em .25em #335c84);
    border-color: currentColor;
  }
  
  > .link-text {
    border-color: inherit;
    border-bottom-style: solid;
    border-bottom-width: thin;
    display: block;
  }
`

export const DecoratedLinkText = styled.strong`
  border-color: inherit;
  border-bottom-style: solid;
  border-bottom-width: thin;
`

export const SubtreeIcon = styled.img`
  max-height: 125px;
  max-width: 125px;
  width: 25vw;
`

export const SubtreeHeading = styled.strong`
  font-size: 2rem;
  text-transform: uppercase;
`

export const SubtreeSectionWrapper = styled.article`
  align-items: center;
  background-color: black;
  border: thin solid #335c84;
  border-radius: .25rem;
  color: white;
  display: flex;
  justify-content: center;
  overflow: hidden;
  padding: 2em;
  position: relative;
  
  &::before {
    background-image: url(${({ bgImage }) => bgImage});
    background-size: cover;
    content: ' ';
    display: block;
    height: 100%;
    opacity: .65;
    width: 100%;
    
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    position: absolute;
  }
`
export const HomeWrapper = styled.main`
  background-color: white;
  border: thin solid #335c84;
  border-radius: .5rem;
  height: 50vh;
  min-height: 400px;
  margin: 1em;
  overflow: hidden;
  padding: .5em;
  
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: 
    "database project";
  grid-gap: .5em;
  
  > :nth-child(1) {
    grid-area: database;
  }
  
  > :nth-child(2) {
    grid-area: project;
  }
`
